var _path, _path2, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExplore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 181,
    height: 170,
    viewBox: "0 0 181 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.6384 51.6766C41.6744 41.9363 58.2117 38.1406 74.1905 41.2214L93.2493 44.896C118.608 49.7853 135.869 73.4505 132.778 99.0906C129.816 123.667 109.054 142.214 84.3003 142.398L47.3883 142.672C33.4384 142.775 20.1761 136.622 11.247 125.904C-5.84158 105.391 -2.23117 74.742 19.1563 58.7616L28.6384 51.6766Z",
    fill: "#F5F7F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6437 16.5047C64.213 13.1294 81.3471 18.5932 92.9037 30.9375L98.8756 37.3165C112.439 51.8047 112.933 74.1769 100.021 89.2491C89.8416 101.132 73.5365 105.766 58.6289 101.012L35.0248 93.4851C20.1171 88.7313 9.50446 75.514 8.0832 59.9314C6.28053 40.1671 19.6343 22.2105 39.0813 18.249L47.6437 16.5047Z",
    fill: "#FFE6DF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3110_13587)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.879 55.2515C124.819 30.7608 164.973 61.7518 145.879 91.0299C142.251 96.5922 136.837 100.753 130.529 102.827L65.8176 124.099C54.8887 127.692 42.875 125.246 34.2207 117.666C9.57309 96.0795 28.6874 55.7109 61.0059 61.0972L74.3972 63.3291C83.6665 64.8739 93.1741 61.8356 99.879 55.2515Z",
    fill: "#3F3D56"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3110_13587)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M142.12 144.702C142.12 144.867 141.988 144.999 141.823 144.999H11.2974C11.1325 144.999 11 144.867 11 144.702C11 144.537 11.1325 144.404 11.2974 144.404H141.823C141.988 144.404 142.12 144.537 142.12 144.702Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.603 130.223L103.102 136.47L98.6039 137.72L97.6042 130.972L101.603 130.223Z",
    fill: "#FFB6B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.85 109.98L104.102 113.979L101.103 118.727L105.351 121.476L112.599 113.229L108.85 109.98Z",
    fill: "#FFB6B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.351 68.7461L111.349 82.2412C111.349 82.2412 129.093 97.7356 127.344 100.984C125.594 104.233 113.848 113.23 113.848 113.23C113.848 113.23 114.72 116.107 112.16 114.918C109.6 113.73 106.851 110.481 106.851 110.481C106.851 110.481 106.851 107.982 108.1 108.482C109.35 108.982 115.098 102.234 115.098 102.234L102.602 90.7382V129.178C102.602 129.178 105.601 131.8 102.602 132.012C99.6035 132.223 96.8545 132.723 96.8545 132.723C96.8545 132.723 93.3558 131.473 94.6053 130.224L90.8567 109.731L88.1077 84.7403L90.1069 71.745L107.351 68.7461Z",
    fill: "#1A1924"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.3537 135.72C99.3537 135.72 99.6036 134.721 100.603 134.721H103.656C103.656 134.721 104.602 138.969 104.352 138.969C104.102 138.969 108.35 144.467 103.852 144.717C99.3537 144.967 98.1041 144.467 98.1041 144.467L97.6043 142.494C97.6043 142.494 96.8546 141.218 97.1045 140.219C97.3544 139.219 99.3537 135.72 99.3537 135.72Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.601 119.477C105.601 119.477 108.472 119.432 107.786 120.204C107.101 120.977 105.851 122.226 105.851 122.226C105.851 122.226 102.879 128.224 101.491 127.099C100.103 125.975 97.8542 113.479 98.6039 111.98C99.3536 110.48 100.353 110.48 100.353 110.48L104.964 113.253C104.964 113.253 102.103 120.227 105.601 119.477Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.6039 47.5026L99.6035 41.2549L92.856 38.5059L91.8563 48.0024L98.6039 47.5026Z",
    fill: "#FFB6B6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M98.6039 47.5026L99.6035 41.2549L92.856 38.5059L91.8563 48.0024L98.6039 47.5026Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.4814 46.6282L99.4786 44.6289L107.976 47.3779C107.976 47.3779 111.724 57.8741 110.475 61.6228C109.225 65.3714 109.225 72.6936 109.225 72.6936C109.225 72.6936 109.1 69.4949 101.853 71.7441C94.6053 73.9933 89.3572 73.7434 89.3572 73.7434L89.1073 64.7466L85.9679 56.7553C84.626 53.3396 86.0723 49.4615 89.3232 47.7587L91.4814 46.6282Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.192 76.0683C129.32 77.4202 129.537 79.0983 128.677 79.8163C127.816 80.5343 126.204 80.0203 125.076 78.6677C124.617 78.1336 124.294 77.4976 124.132 76.8127L119.423 71.0243L121.717 69.168L126.535 74.8073C127.18 75.0893 127.748 75.5217 128.192 76.0683Z",
    fill: "#FFB6B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.612 47.457L105.974 53.9488L113.995 66.7888L122.183 75.0186L124.838 72.8167L116.579 62.5413L110.319 49.3017L107.612 47.457Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.708 41.1919C132.42 40.7698 136.618 34.5694 136.084 27.343C135.55 20.1166 130.486 14.6006 124.774 15.0228C119.061 15.4449 114.864 21.6453 115.398 28.8717C115.932 36.0981 120.995 41.6141 126.708 41.1919Z",
    fill: "#FD5B2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.615 40.1387L126.675 41.9048L127.473 43.5397L124.143 43.3699L125.543 41.962L125.385 40.3573L126.615 40.1387Z",
    fill: "#FD5B2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.8987 43.2638C100.699 43.2638 103.78 40.1831 103.78 36.3829C103.78 32.5826 100.699 29.502 96.8987 29.502C93.0985 29.502 90.0178 32.5826 90.0178 36.3829C90.0178 40.1831 93.0985 43.2638 96.8987 43.2638Z",
    fill: "#FFB6B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3496 27.1317C96.5487 27.2479 96.8154 27.0721 96.8792 26.8506C96.9431 26.629 96.8687 26.3938 96.795 26.1754L96.4237 25.0758C96.1604 24.2959 95.8809 23.4888 95.3107 22.8952C94.45 21.9992 93.0821 21.7713 91.8507 21.9364C90.2694 22.1485 88.7092 23.0047 87.974 24.4207C87.2387 25.8366 87.5517 27.8124 88.8803 28.6958C86.9868 30.866 86.3268 33.2847 86.431 36.163C86.5352 39.0413 89.6718 41.6902 91.7173 43.7179C92.1741 43.441 92.5894 42.1433 92.3382 41.6719C92.087 41.2004 92.4469 40.6543 92.1358 40.2201C91.8247 39.7858 91.5645 40.4772 91.879 40.0455C92.0774 39.773 91.3028 39.1462 91.5978 38.9832C93.0247 38.1944 93.4993 36.4159 94.3955 35.0539C95.4764 33.4111 97.3264 32.2986 99.2843 32.1141C100.363 32.0124 101.502 32.1965 102.386 32.8227C103.27 33.4488 103.842 34.5677 103.637 35.6314C104.168 35.0923 104.432 34.3024 104.333 33.5524C104.233 32.8024 103.772 32.1088 103.118 31.7271C103.516 30.4136 103.175 28.9026 102.253 27.8861C101.331 26.8696 97.5915 27.0428 96.2455 27.3103",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.1405 32.1543C94.3578 32.3467 93.0707 33.891 91.9838 35.317C91.3573 36.139 90.7011 37.0467 90.7168 38.0801C90.7327 39.1249 91.4312 40.021 91.7651 41.0111C92.3107 42.6294 91.7789 44.5549 90.48 45.6638C91.7635 45.9074 93.151 44.945 93.3725 43.6576C93.6305 42.1588 92.4943 40.7122 92.6289 39.1974C92.7474 37.8628 93.7991 36.8357 94.6933 35.8378C95.5874 34.8399 96.4271 33.5158 96.0158 32.2406",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5783 73.6191H38.1796C32.351 73.6191 27.6259 78.3442 27.6259 84.1728V134.013C27.6259 139.842 32.3509 144.567 38.1796 144.567H89.5783C95.4069 144.567 100.132 139.842 100.132 134.013V84.1728C100.132 78.3442 95.4069 73.6191 89.5783 73.6191Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5783 144.816H38.1796C32.2225 144.816 27.376 139.97 27.376 134.013V84.1727C27.376 78.2157 32.2225 73.3691 38.1796 73.3691H89.5783C95.5354 73.3691 100.382 78.2157 100.382 84.1727V134.013C100.382 139.97 95.5354 144.816 89.5783 144.816ZM38.1796 73.869C32.498 73.869 27.8758 78.4912 27.8758 84.1727V134.013C27.8758 139.694 32.498 144.317 38.1796 144.317H89.5783C95.2598 144.317 99.8821 139.694 99.8821 134.013V84.1727C99.8821 78.4912 95.2598 73.869 89.5783 73.869H38.1796Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.1548 78.5223C84.8131 78.5223 85.3467 77.9887 85.3467 77.3305C85.3467 76.6723 84.8131 76.1387 84.1548 76.1387C83.4966 76.1387 82.963 76.6723 82.963 77.3305C82.963 77.9887 83.4966 78.5223 84.1548 78.5223Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.4324 78.5223C88.0906 78.5223 88.6242 77.9887 88.6242 77.3305C88.6242 76.6723 88.0906 76.1387 87.4324 76.1387C86.7741 76.1387 86.2405 76.6723 86.2405 77.3305C86.2405 77.9887 86.7741 78.5223 87.4324 78.5223Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.7099 78.5223C91.3681 78.5223 91.9017 77.9887 91.9017 77.3305C91.9017 76.6723 91.3681 76.1387 90.7099 76.1387C90.0517 76.1387 89.5181 76.6723 89.5181 77.3305C89.5181 77.9887 90.0517 78.5223 90.7099 78.5223Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4947 127.117C36.1244 127.117 35.8232 127.418 35.8232 127.789C35.8232 127.969 35.8929 128.136 36.0195 128.259C36.1471 128.39 36.3143 128.46 36.4947 128.46H90.2499C90.6201 128.46 90.9214 128.159 90.9214 127.789C90.9214 127.608 90.8516 127.441 90.7251 127.318C90.5974 127.187 90.4302 127.117 90.2499 127.117H36.4947Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2379 126.893V128.683H36.4947C36.2485 128.683 36.0246 128.585 35.8635 128.419C35.6978 128.258 35.5994 128.034 35.5994 127.788C35.5994 127.295 36.0023 126.893 36.4947 126.893L65.2379 126.893Z",
    fill: "#FD5B2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.1307 123.536H80.1775C79.1902 123.536 78.3869 122.733 78.3869 121.746C78.3869 120.758 79.1902 119.955 80.1775 119.955H89.1307C90.118 119.955 90.9213 120.758 90.9213 121.746C90.9213 122.733 90.118 123.536 89.1307 123.536Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.495 124.817L49.2363 103.787L48.7572 103.93L54.994 124.885",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.7117 76.9576C61.424 76.5354 65.6218 70.335 65.0878 63.1086C64.5537 55.8822 59.4901 50.3662 53.7777 50.7884C48.0654 51.2105 43.8676 57.4109 44.4016 64.6373C44.9357 71.8637 49.9993 77.3797 55.7117 76.9576Z",
    fill: "#FD5B2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4944 76.957H54.9946V126.799H55.4944V76.957Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5176 103.178L50.0787 104.853L51.3099 106.193L48.0699 106.98L49.01 105.231L48.4007 103.738L49.5176 103.178Z",
    fill: "#FD5B2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6188 75.9043L55.6788 77.6704L56.4769 79.3054L53.147 79.1355L54.5467 77.7276L54.3885 76.1229L55.6188 75.9043Z",
    fill: "#FD5B2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6859 103.617C55.0358 101.571 57.2739 94.4254 54.6849 87.6576C52.0959 80.8898 45.6603 77.0624 40.3105 79.1089C34.9607 81.1554 32.7225 88.3009 35.3115 95.0687C37.9005 101.837 44.3361 105.664 49.6859 103.617Z",
    fill: "#FD5B2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.097 71.06C96.7828 71.5689 97.8867 72.8513 97.5626 73.9241C97.2385 74.997 95.6094 75.4538 93.923 74.9444C93.2466 74.7502 92.6266 74.3968 92.1147 73.9138L84.9991 71.6671L85.8947 68.8555L93.0198 70.9174C93.7137 70.7983 94.4259 70.8472 95.097 71.06Z",
    fill: "#FFB6B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.7346 52.6269L90.2319 47.1289L89.982 57.6251L82.9845 66.6219L90.4818 69.6208L90.2319 73.9027C90.2319 73.9027 80.7353 71.6201 79.2359 71.3702C77.7364 71.1203 76.4869 67.6215 76.4869 67.6215L82.7346 52.6269Z",
    fill: "#E6E6E6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3110_13587",
    x: 3.00018,
    y: 0.390625,
    width: 227.866,
    height: 179.336,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 30,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.411765 0 0 0 0 0.172549 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3110_13587"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3110_13587",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3110_13587"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 131.12,
    height: 130,
    fill: "white",
    transform: "translate(11 15)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExplore);
export default __webpack_public_path__ + "static/media/Explore.2e298d0bb0a4e5ca072a0dfe56ecc2a3.svg";
export { ForwardRef as ReactComponent };